import { Record } from "immutable";

import subwayDisplayOptions from "../../../../constants/subwayDisplayOptions";
import subwayTextLineCountOptions from "../../../../constants/subwayTextLineCountOptions";
import createFromJS from "../../../createFromJS";

export const SubwayViewSettingsRecord = Record({
  showDates: false,
  display: subwayDisplayOptions.SUBWAY,
  numTextLines: subwayTextLineCountOptions.ALL_LINES
});

createFromJS.registerCallback(
  "SubwayViewSettingsRecord",
  createFromJS.createPrimitiveCallback(SubwayViewSettingsRecord)
);
